export default __webpack_public_path__ + "static/media/main-bg-item1.ad77f8c3.png";